export function getDisplayName(names: string[] = [], suffixes: string[] = []) {
  return filterJoin([
    filterJoin(names, ' '),
    ...suffixes
  ], ', ');
}

function filterJoin(arr: string[], separator: string) {
  return arr.map(val => val && val.trim())
    .filter(val => val)
    .join(separator);
}
